import { CLASS_COLORS, type WowClass } from '@moussenaires/shared';
import { useTranslation } from 'react-i18next';

import './ClassBadge.css';

const CLASS_LABEL_KEY: Record<WowClass, string> = {
  'death-knight': 'Death Knight',
  'demon-hunter': 'Demon Hunter',
  druid: 'Druid',
  evoker: 'Evoker',
  hunter: 'Hunter',
  mage: 'Mage',
  monk: 'Monk',
  paladin: 'Paladin',
  priest: 'Priest',
  rogue: 'Rogue',
  shaman: 'Shaman',
  warlock: 'Warlock',
  warrior: 'Warrior',
};

/** Class names aren't translated — they're proper nouns players recognise identically in FR/EN clients. */
export function ClassBadge({ wowClass, spec }: { wowClass: WowClass; spec?: string | null }) {
  const color = CLASS_COLORS[wowClass];
  return (
    <span
      className="class-badge"
      style={{
        color,
        borderColor: `color-mix(in srgb, ${color} 45%, transparent)`,
        background: `color-mix(in srgb, ${color} 14%, transparent)`,
      }}
    >
      {spec ? `${spec} ${CLASS_LABEL_KEY[wowClass]}` : CLASS_LABEL_KEY[wowClass]}
    </span>
  );
}

const FACTION_CREST: Record<'alliance' | 'horde', string> = {
  alliance: '/alliance-crest.webp',
  horde: '/horde-crest.png',
};

export function FactionIcon({
  faction,
  size = 22,
}: {
  faction: 'alliance' | 'horde' | 'neutral';
  size?: number;
}) {
  const { t } = useTranslation();
  if (faction === 'neutral') return null;
  return (
    <span
      className={`faction-icon faction-icon-${faction}`}
      title={t(`roster.faction`)}
      aria-hidden="true"
      style={{ width: size, height: size }}
    >
      {/* The two crests aren't the same aspect ratio (Alliance's shield is
          taller than Horde's near-square emblem) — a fixed-size box with
          object-fit is what keeps both centered at the same visual size
          without stretching either one. */}
      <img src={FACTION_CREST[faction]} alt="" />
    </span>
  );
}
